import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';

import { useStateValue } from '../context/state.jsx';
import { setProjectViewType, setProjectMapGroupBy } from '../context/datasets.js';

const MapViewType = ({
	projectViewType,
	projectMapGroupBy,
	activityCodeTypes
}) => {
	const [, dispatch] = useStateValue();

	const mapGroupByListItemClick = type => {
		dispatch(setProjectViewType('Map'));
		dispatch(setProjectMapGroupBy(type));
	};

	const mapGroupByItems = Object.keys(activityCodeTypes).map((activityCodeTypeId, index, array) => {
		const { name } = activityCodeTypes[activityCodeTypeId];
		const checked = projectViewType === 'Map' && projectMapGroupBy === activityCodeTypeId;
		const classes = classnames('groupByListItemWrapper', {'no-bottom-border': index === array.length - 1});
		return (
			<div
				key={activityCodeTypeId}
				className={classes}>
				<ListGroupItem
					onClick={() => { mapGroupByListItemClick(activityCodeTypeId); }}>
					<input
						type="radio"
						className="groupByRadio"
						name="mapGroupByRadio"
						value={activityCodeTypeId}
						checked={checked}
						readOnly
						aria-label={`Map grouping ${name}`} />
					{name}
				</ListGroupItem>
			</div>
		);
	});
	const header = (
		<div>
			<input
				type="radio"
				className="projectViewTypeRadio"
				name="projectViewTypeRadio"
				value="Map"
				checked={projectViewType === 'Map'}
				readOnly
				aria-label="Map" />
			Map
			<span className="glyphicon glyphicon-plus rightGlyph"></span>
			<span className="glyphicon glyphicon-minus rightGlyph"></span>
		</div>
	);
	return (
		<Panel className="mapGroupPanel">
			<Panel.Heading>
				<Panel.Title toggle>{header}</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<ListGroup>
					{mapGroupByItems}
				</ListGroup>
			</Panel.Collapse>
		</Panel>
	);
};

export default MapViewType;

MapViewType.propTypes = {
	projectViewType: PropTypes.string,
	projectMapGroupBy: PropTypes.string,
	activityCodeTypes: PropTypes.object
};